import React from 'react';
import { AppBar, Toolbar, Avatar, Typography, Box, Button, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DescriptionIcon from '@mui/icons-material/Description';
import PeopleIcon from '@mui/icons-material/People';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import LogoutIcon from '@mui/icons-material/Logout';

const NavBar = ({ user, logout }) => {
  const navigate = useNavigate();

  return (
    <AppBar position="static" sx={{ px: 2, py: 1 }}>
      <Toolbar sx={{ px: 2 }}>
        <Avatar src="/logo64.png" sx={{ width: 64, height: 64, mr: 2 }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: 48 }}>
          <Typography variant="h6" sx={{ lineHeight: 1.3 }}>
            {user?.name}
          </Typography>
          {user?.organization && (
            <Typography variant="body2" sx={{ lineHeight: 1.8, opacity: 0.85 }}>
              {user.organization}
            </Typography>
          )}
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        {/* Навигация */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Button color="inherit" startIcon={<DescriptionIcon />} onClick={() => { window.location.hash = ''; navigate('/'); }}>Заявки</Button>
          {user?.role === 'admin' && (
            <>
              <Button color="inherit" startIcon={<PeopleIcon />} onClick={() => { window.location.hash = 'users'; navigate('/users'); }}>Пользователи</Button>
              <Button color="inherit" startIcon={<BusinessCenterIcon />} title="Проекты" onClick={() => { window.location.hash = 'projects'; navigate('/projects'); }}>Проекты</Button>
            </>
          )}
        </Box>
        <Divider
          orientation="vertical"
          flexItem
          sx={{ mx: 2, borderColor: 'rgba(255,255,255,0.5)', height: '32px', alignSelf: 'center' }}
        />
        {/* Пользователь и выход */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {user?.role === 'admin' ? 'Администратор' : 
             user?.role === 'manager' ? 'Менеджер' : 
             user?.role === 'agent' ? 'Агент' : 'Пользователь'}
          </Typography>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ mx: 1, borderColor: 'rgba(255,255,255,0.5)', height: '32px', alignSelf: 'center' }}
          />
          <Button color="inherit" startIcon={<LogoutIcon />} onClick={() => { logout(); window.location.replace('/auth'); }}>Выйти</Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
